export class CargoPlanilla {
  idcargo?: number;
  codigo?: string;
  nombre?: string;
  descripcion?: string;
  editando?: boolean;
  constructor() {}
}
